module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg2_mid.8f6d46c1.jpg";